module.exports = __webpack_public_path__ + "fonts/Roboto-Medium.02aa6e7.eot";